import { BasicEvent } from "./BasicEvent";
export class AttributEventMessage extends BasicEvent {
    grupp: string;
    nyckel: string;
    varde: string;
    guid: string;
    uDate: string;
    constructor($type: string) {
        super($type);
    }
}
